import { ChevronRight, ArrowLeft } from 'lucide-react';

export interface BreadcrumbSegment {
  label: string;
  target: string;
}

interface ShuddhoshikhaBreadcrumbProps {
  segments: BreadcrumbSegment[];
  onNavigate: (target: string) => void;
}

export const ShuddhoshikhaBreadcrumb = ({ segments, onNavigate }: ShuddhoshikhaBreadcrumbProps) => {
  const handleBackClick = () => {
    if (segments.length === 0) {
      onNavigate('home');
    } else if (segments.length === 1) {
      onNavigate('home');
    } else {
      onNavigate(segments[segments.length - 2].target);
    }
  };

  return (
    <div className="flex items-center gap-3 mb-6">
      {/* Desktop-only Premium Back Arrow Button */}
      <button
        onClick={handleBackClick}
        className="hidden md:flex items-center justify-center w-10 h-10 rounded-[12px] bg-white dark:bg-[#1E1E1E]/60 border border-gray-100 dark:border-white/5 text-gray-500 dark:text-gray-400 hover:text-slate-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-white/5 active:scale-95 transition-all cursor-pointer flex-shrink-0"
        aria-label="ফিরে যান"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>

      {/* Breadcrumb Path */}
      <nav className="flex-1 flex items-center space-x-2 text-sm font-bangla text-gray-500 dark:text-gray-400 bg-white dark:bg-[#1E1E1E]/60 border border-gray-100 dark:border-white/5 py-3 px-4 rounded-[12px] flex-wrap transition-colors duration-200">
        <span className="cursor-pointer hover:text-[#00C9A7]" onClick={() => onNavigate('home')}>
          অনুশীলন
        </span>
        {segments.map((seg, idx) => (
          <div key={idx} className="flex items-center space-x-2">
            <ChevronRight className="w-4 h-4 text-gray-600 flex-shrink-0" />
            <span
              className={`cursor-pointer transition-colors ${
                idx === segments.length - 1 ? 'text-slate-900 dark:text-white font-semibold' : 'hover:text-[#00C9A7]'
              }`}
              onClick={() => idx !== segments.length - 1 && onNavigate(seg.target)}
            >
              {seg.label}
            </span>
          </div>
        ))}
      </nav>
    </div>
  );
};
